module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-6.c850cf4e.jpg";